import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  & > * {
    flex: 1;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  margin-right: 0.5rem;
`;
